import { render, staticRenderFns } from "./HtmlLink.vue?vue&type=template&id=118ccb50&scoped=true&"
import script from "./HtmlLink.vue?vue&type=script&lang=js&"
export * from "./HtmlLink.vue?vue&type=script&lang=js&"
import style0 from "./HtmlLink.vue?vue&type=style&index=0&id=118ccb50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118ccb50",
  null
  
)

export default component.exports